module.exports = __webpack_public_path__ + "img/play.8ccc2017.svg";